import { render } from "./InviteFormSidebar.vue?vue&type=template&id=15a61125"
import script from "./InviteFormSidebar.vue?vue&type=script&lang=js"
export * from "./InviteFormSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__